import NumericalSubtitle from './NumericalSubtitle';

export default NumericalSubtitle;
